export class CdxFile {
  cdx_id: string;
  uuid: string;
  filename: string;
  fileSize: number;
  format: string;
  type: string;
  url: any;
}
